import React from 'react'
import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'
import PropTypes from 'prop-types'

import Barcode from '~/components/Icons/Barcode'

function CountableBarcode ({ count, disabled, onOpen, isError, ...props }) {
  const badgeColor = count ? 'default' : 'error'
  const badgeVariant = count ? 'standard' : 'dot'
  return (
    <IconButton
      disabled={disabled}
      onClick={onOpen}
      sx={{ color: isError ? 'red' : 'primary' }}
      size="large"
      {...props}
    >
      <Badge variant={badgeVariant} badgeContent={count || null} color={badgeColor}>
        <Barcode />
      </Badge>
    </IconButton>
  )
}

CountableBarcode.defaultProps = {
  disabled: false
}

CountableBarcode.propTypes = {
  count: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  onOpen: PropTypes.func.isRequired,
  isError: PropTypes.bool
}

export default CountableBarcode
